import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'aditya-privacypolicy',
  templateUrl: './privacypolicy.component.html',
  styleUrls: ['./privacypolicy.component.css']
})
export class PrivacypolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
